export default __webpack_public_path__ + "static/media/logo.654bc689.png";